module.exports = __webpack_public_path__ + "images/021a483069170382b0970cb5baa623e9.png";